import { IterableElement } from 'type-fest'

import { BSC_TOKEN_TICKERS } from './token-tickers'
import { Ticker } from '../ticker'

export const BSC_TICKERS = [Ticker.BNB, ...BSC_TOKEN_TICKERS]

export type BscTicker = IterableElement<typeof BSC_TICKERS>
